import { autoinject, bindable, noView, Aurelia } from 'aurelia-framework';
import { LoginController } from '../../controllers/login-controller'
import { Router } from 'aurelia-router';
import { BusyService } from "../../services/busy-service";
import { WebApiService } from '../../services/web-api-service';
import { SecurityService } from '../../services/security-service';


@autoinject()
export class NavbarPublic {

    constructor(private loginController: LoginController, private router: Router,
        private busyService: BusyService,
        private api: WebApiService,
        private auth: SecurityService,
        public aurelia: Aurelia) {
        this.environment = (<any>aurelia.host.attributes).environment.value;
    }


    environment: string;

    async login() {
        (<any>window.location) = "login";
    }


    async logout() {
        (<any>window.location) = "logout";
    }

    async signup() {
        this.router.navigateToRoute("signup");
    }

}